(function () {
  const PRICE_BLOCK_SELECTOR = '[data-type="price"], [data-type="rb-rent-pricing"]';

  function isPurchaseModeActive(productInfo) {
    return Boolean(
      productInfo.querySelector(
        '.rb-purchase-mode:not(.rb-purchase-mode--design-mode) .rb-purchase-mode__cards'
      )
    );
  }

  function syncPurchaseModeVisibility(root) {
    const productInfos =
      root && typeof root.matches === 'function' && root.matches('product-info')
        ? [root]
        : document.querySelectorAll('product-info');

    productInfos.forEach((productInfo) => {
      const hidePriceBlocks = isPurchaseModeActive(productInfo);

      productInfo.querySelectorAll(PRICE_BLOCK_SELECTOR).forEach((block) => {
        block.classList.toggle('hidden', hidePriceBlocks);
        if (hidePriceBlocks) {
          block.setAttribute('hidden', '');
          block.setAttribute('aria-hidden', 'true');
        } else {
          block.removeAttribute('hidden');
          block.removeAttribute('aria-hidden');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncPurchaseModeVisibility());
  } else {
    syncPurchaseModeVisibility();
  }

  document.addEventListener('product-info:loaded', (event) => {
    syncPurchaseModeVisibility(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => syncPurchaseModeVisibility());
  }
})();
